import { render, staticRenderFns } from "./TreeDefault.vue?vue&type=template&id=b225e324&"
import script from "./TreeDefault.vue?vue&type=script&lang=js&"
export * from "./TreeDefault.vue?vue&type=script&lang=js&"
import style0 from "./TreeDefault.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports